'use client';

import { useEffect } from 'react';
import { setupDeepLinks } from '@/lib/capacitor-deep-link-handler';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';

/**
 * Initialize Capacitor features when the app loads
 * Must be a client component to access browser APIs
 */
export function CapacitorInit() {
  useEffect(() => {
    // Only run on native platforms
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    console.log('[Capacitor] Initializing app on platform:', Capacitor.getPlatform());

    // Setup deep link handlers
    setupDeepLinks().catch((error) => {
      console.error('[Capacitor] Error setting up deep links:', error);
    });

    // Hide splash screen after a brief delay (allow React to hydrate)
    const hideSplash = setTimeout(async () => {
      try {
        await SplashScreen.hide();
        console.log('[Capacitor] Splash screen hidden');
      } catch (error) {
        console.error('[Capacitor] Error hiding splash screen:', error);
      }
    }, 500);

    return () => {
      clearTimeout(hideSplash);
    };
  }, []);

  // This component doesn't render anything
  return null;
}
